export function checkIsLogin() {
  const isCustomLogin = localStorage.getItem('isCustomLogin') === 'true';
  return isCustomLogin;
}
